import axios from '@/plugins/axios';
export function listShop(projectId) {
  return axios.get('/shopList/listShop', {
    params: {
      projectId: projectId
    }
  });
}
export function saveShop(params) {
  return axios.get('/shopList/saveShop', {
    params: params
  });
}
export function editShop(params) {
  return axios.get('/shopList/editShop', {
    params: params
  });
}
export function deleteShop(params) {
  return axios.get('/shopList/deleteShop', {
    params: params
  });
}
export function listSupplier(projectId, createId) {
  return axios.get('/supplierList/listSupplier', {
    params: {
      projectId: projectId,
      createId: createId
    }
  });
}
export function editSupplier(params) {
  return axios.get('/supplierList/editSupplier', {
    params: {
      supplierId: params.supplierId,
      supplierPrice: params.supplierPrice,
      supplierSubtotal: params.supplierSubtotal,
      remark: params.remark,
      updateId: params.updateId
    }
  });
}
